import Grid from '@mui/material/Grid2';
// import from MUI Icons
import { CheckCircleOutline } from '@mui/icons-material';
import { BoxCenterStart } from '../style/box';
import { commonStyles } from "../style/common";
import { Complete } from "../components/complete";

const CalloutComplete = () => {
    return (
        <BoxCenterStart sx={commonStyles.page}>
            <Grid
                container
                spacing={7}
                columns={12}
                sx={commonStyles.container}
            >
                <Complete
                    iconComponent={CheckCircleOutline}
                    color={"green"}
                    mainMessage={"招集連絡への回答が完了しました。"}
                    subMessage={"今後、業務割当が行われた場合は SMS でご連絡しますので、必ずご確認ください。\n作業は終了しましたので、このブラウザを閉じてください。"}
                />
            </Grid>
        </BoxCenterStart>
    );
};

export default CalloutComplete;